<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-loading="loading">
            <van-nav-bar :title="$t('success.title')" fixed placeholder left-arrow @click-left="returnpev" />
            <div class="orderinfos">
              <p>{{ $t("success.orderamount") }}</p>
              <h1>{{ currencySymbol }}{{ order.total }}</h1>
              <p>{{ $t("success.goodsname") }}{{ order.title }}</p>
              <p>{{ $t("success.buyvalue") }}{{ order.goodstotal }} ML</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Starter page component
 */
import { getCurrencySymbol, normalizeCurrency } from "@/utils/currency";

export default {
  data() {
    return {
      loading: true,
      paymentloading: false,
      payway: [],
      order: {
        total: 0.0,
      },
      radio: "",
      currency: "CNY",
    };
  },
  mounted() {
    this.getpaymentstatus();
  },
  computed: {
    currencySymbol() {
      return getCurrencySymbol(this.$i18n, this.currency);
    },
  },
  watch: {
    "$i18n.locale"() {
      this.getpaymentstatus();
    },
  },
  methods: {
    getpaymentstatus() {
      var that = this;
      that.$axios
        .post(that.apiuri, {
          action: "getorderinfo",
          ordersn: that.$route.params.id,
          lang: that.$i18n.locale,
        })
        .then(function (response) {
          that.loading = false;
          that.order = response.data.data;
          that.currency = normalizeCurrency(response.data.currency || (response.data.data && response.data.data.currency));
        });
    },
    returnpev() {
      this.$router.push({
        name: "Home",
      });
    },
  },
};
</script>
<style>
.card-body {
  padding: 0;
}
.van-nav-bar .van-icon {
  color: #000;
}
.bottom_logo {
  bottom: 3rem;
}
.orderinfos {
  text-align: center;
  padding-top: 8rem;
}
</style>
